import { Link, type LinkProps } from 'react-router'
import { Button, type ButtonProps } from '@/components/ui/button'
import { cn } from '@/helpers/utils'

export type ButtonLinkProps = LinkProps &
	ButtonProps & {
		disabled?: boolean
		ref?: React.Ref<HTMLAnchorElement>
	}

function ButtonLink({
	variant,
	children,
	disabled,
	size = 'md',
	shape = 'rectangle',
	className,
	ref,
	...props
}: ButtonLinkProps) {
	return (
		<Button
			asChild
			className={cn('group', className)}
			data-slot='button'
			disabled={disabled}
			shape={shape}
			size={size}
			variant={variant}
		>
			<Link
				{...props}
				aria-disabled={disabled}
				onClick={(event) => {
					if (disabled) {
						event.preventDefault()
						event.stopPropagation()
					} else {
						props.onClick?.(event)
					}
				}}
				ref={ref}
				tabIndex={disabled ? -1 : undefined}
			>
				{children}
			</Link>
		</Button>
	)
}

export { ButtonLink }
